export const EventLocations = {
  calendar: 'Calendar',
  inProgressVisit: 'In-progress visit',
  intakeForm: 'Intake form',
  patientCharts: 'Patient charts',
  upcomingVisitNotes: 'Upcoming visit notes',
  visits: 'Visits',
  visitNote: 'Visit note',
  waitingRoom: 'Waiting room',
}
